import React from "react";
import { FileText } from "lucide-react";

interface DocumentContextBarProps {
  documentName: string;
  details?: string;
}

export function DocumentContextBar({
  documentName,
  details,
}: DocumentContextBarProps) {
  return (
    <div className="mx-3 mt-2 bg-accent-cyan/6 border border-accent-cyan/12 rounded-xl px-3 py-2 text-[11px] flex items-center gap-2 shrink-0">
      <FileText size={13} className="text-accent-cyan shrink-0" />
      <span className="font-medium text-text-primary truncate">{documentName}</span>
      {details && (
        <>
          <span className="text-text-muted">&middot;</span>
          <span className="text-text-muted truncate">{details}</span>
        </>
      )}
    </div>
  );
}
